import { createResource, Show } from "solid-js";
import { PT } from "~/utils/products";
import {  useSiteContext } from "~/utils/contexts";
import { BaseProductSlider } from "../ui";
import { RecentlyViewedProduct } from "~/utils/createRecentlyViewed";
import { Product } from "~/services/roma-api/products/types";

export const RecentlyViewed = () => {
  const { recentlyViewed } = useSiteContext();
  // TODO: Change to createAsync call/useProducts/fix TS
  const [dataList] = createResource(
    () => recentlyViewed(),
    async (skuArr) => {
      const skus = skuArr;
      // const skus = JSON.parse(skuStr) || [];
      const list = skus.map(
        (item: RecentlyViewedProduct) => item.mouldingNumber
      );
      const paths = new URLSearchParams();
      const skuList = list.join(",");
      paths.set(
        "fields",
        "Name,SKU,Collection,Category,IsNew,Images,Width,Height,Rabbet,ColourDescription"
      );
      paths.set("skus", skuList);
      const request = await fetch(
        `${import.meta.env.VITE_ROMA_API}/products?${paths}`
      );
      const data = await request.json();
      const dictionary = data.Results.reduce(
        (memo: Record<string, any>, item: Product) => {
          if (memo[item.SKU]) return memo;
          memo[item.SKU] = item;
          return memo;
        },
        {} as Record<string, Product>
      );

      const results = skus.reduce((memo, item) => {
        if (dictionary[item.mouldingNumber]) {
          memo.push({
            type: item.type,
            data: dictionary[item.mouldingNumber],
          });
        }
        return memo;
      }, [] as { type: PT; data: Product }[]);
      return results;
    }
  );

  return (
    <Show when={recentlyViewed()?.length > 0 && dataList.latest}>
      <BaseProductSlider
        title="Recently Viewed"
        productList={dataList.latest!}
      />
    </Show>
  );
};
